import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=7bf37a11&scoped=true&"
import script from "./Recovery.vue?vue&type=script&lang=ts&"
export * from "./Recovery.vue?vue&type=script&lang=ts&"
import style0 from "./Recovery.vue?vue&type=style&index=0&id=7bf37a11&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf37a11",
  null
  
)

export default component.exports